// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import MuiHeader from "../../components/MuiHeader";
// import {
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Typography,
//   InputAdornment,
//   IconButton,
//   Divider,
//   Paper,
//   Chip,
//   FormHelperText,
//   Stack,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Tooltip,
// } from "@mui/material";
// import {
//   PersonOutline as PersonIcon,
//   MailOutline as MailIcon,
//   LockOutlined as LockIcon,
//   PhoneOutlined as PhoneIcon,
//   HomeOutlined as HomeIcon,
//   CalendarTodayOutlined as CalendarIcon,
//   BadgeOutlined as BadgeIcon,
//   WcOutlined as GenderIcon,
//   Visibility,
//   VisibilityOff,
//   ArrowBack as ArrowBackIcon,
//   HowToReg as HowToRegIcon,
//   RestartAlt as ResetIcon,
//   CheckCircleOutline as SuccessIcon,
//   PersonAdd as PersonAddIcon,
//   Group as GroupIcon,
//   Refresh as RefreshIcon,
// } from "@mui/icons-material";
// import Swal from "sweetalert2";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import bcrypt from "bcryptjs";
// import api from "../../api/api";

// const initialFormState = {
//   username: "",
//   userType: "",
//   email: "",
//   password: "",
//   status: "Inactive",
//   gender: "",
//   dob: "",
//   contactNumber: "",
//   permanentAddress: "",
// };

// function UserRegister() {
//   const navigate = useNavigate();
//   const [view, setView] = useState("create"); // "create" | "fetch"

//   // ─── Create User state ───────────────────────────────────────────────────
//   const [formData, setFormData] = useState(initialFormState);
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showPreviewPassword, setShowPreviewPassword] = useState(false);
//   const [submittedData, setSubmittedData] = useState(null);
//   const [submitting, setSubmitting] = useState(false);

//   // ─── Fetch Users state ────────────────────────────────────────────────────
//   const [users, setUsers] = useState([]);
//   const [fetching, setFetching] = useState(false);
//   const [visiblePasswords, setVisiblePasswords] = useState({}); // { [userId]: bool }

//   // ─── Handlers: Create User ────────────────────────────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.username.trim()) newErrors.username = "User Name is required";
//     if (!formData.userType) newErrors.userType = "Please select a User Type";
//     if (!formData.email.trim()) {
//       newErrors.email = "Email ID is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
//       newErrors.email = "Please enter a valid email address";
//     }
//     if (!formData.password) {
//       newErrors.password = "Password is required";
//     } else if (formData.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters";
//     } else if (!/[a-zA-Z]/.test(formData.password)) {
//       newErrors.password = "Password must include at least one letter";
//     } else if (!/[0-9]/.test(formData.password)) {
//       newErrors.password = "Password must include at least one digit";
//     } else if (!/[@_!#$%^&*(),.?":{}|<>\-]/.test(formData.password)) {
//       newErrors.password = "Password must include at least one special character (@, _, !, # etc.)";
//     }
//     if (!formData.status) newErrors.status = "Please select a Status";
//     if (!formData.gender) newErrors.gender = "Please select Gender";
//     if (!formData.dob) newErrors.dob = "Date of Birth is required";
//     if (!formData.contactNumber.trim()) {
//       newErrors.contactNumber = "Contact Number is required";
//     } else if (!/^[0-9]{10}$/.test(formData.contactNumber.trim())) {
//       newErrors.contactNumber = "Please enter a valid 10-digit contact number";
//     }
//     if (!formData.permanentAddress.trim()) {
//       newErrors.permanentAddress = "Permanent Address is required";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) {
//       toast.error("Please fill all required fields correctly!");
//       return;
//     }
//     try {
//       setSubmitting(true);
//       const plainPassword = formData.password;

//       // Hash password on frontend before sending to backend
//       const saltRounds = 10;
//       const hashedPassword = await bcrypt.hash(plainPassword, saltRounds);

//       const payload = {
//         ...formData,
//         password: hashedPassword,
//         recoveryPassword: plainPassword,
//       };
//       const response = await api.post("/registerUser", payload);

//       if (response.status === 200 || response.status === 201) {
//         setSubmittedData({ ...formData, plainPassword });
//         setFormData(initialFormState);
//         setErrors({});
//         setShowPreviewPassword(false);

//         Swal.fire({
//           icon: "success",
//           title: "User Registered Successfully!",
//           html: `
//             <div style="text-align: left; font-size: 14px; line-height: 1.6; padding: 10px; background: #f8fafc; border-radius: 8px;">
//               <p style="color: #2e7d32; font-weight: 600; margin-bottom: 8px;">Saved to Local MongoDB (mongodb://localhost:27017/)</p>
//               <hr style="border: none; border-top: 1px solid #e2e8f0; margin-bottom: 10px;" />
//               <p><strong>User Name:</strong> ${formData.username}</p>
//               <p><strong>User Type:</strong> ${formData.userType}</p>
//               <p><strong>Email ID:</strong> ${formData.email}</p>
//               <p><strong>User ID:</strong> <span style="color: #1565c0; font-weight: 600;">${formData.email.trim().toLowerCase()}</span></p>
//               <p><strong>Password:</strong> <span style="background: #fff3e0; padding: 2px 8px; border-radius: 4px; font-family: monospace; font-weight: 600; color: #e65100;">${plainPassword}</span></p>
//               <p><strong>Status:</strong> ${formData.status}</p>
//               <p><strong>Gender:</strong> ${formData.gender}</p>
//               <p><strong>Date of Birth:</strong> ${formData.dob}</p>
//               <p><strong>Contact:</strong> ${formData.contactNumber}</p>
//               <p><strong>Address:</strong> ${formData.permanentAddress}</p>
//             </div>
//           `,
//           confirmButtonText: "Done",
//           confirmButtonColor: "#1976d2",
//         });

//         toast.success(response.data?.message || "User registered successfully in local MongoDB!");
//       } else {
//         toast.error("Failed to register user. Please try again.");
//       }
//     } catch (err) {
//       console.error("Error registering user:", err);
//       const errorMsg =
//         err.response?.data?.message ||
//         err.message ||
//         "Failed to register user. Please ensure local server is running.";
//       toast.error(errorMsg);
//       Swal.fire({
//         icon: "error",
//         title: "Registration Failed",
//         text: errorMsg,
//         confirmButtonColor: "#d32f2f",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleReset = () => {
//     setFormData(initialFormState);
//     setErrors({});
//     setSubmittedData(null);
//     toast.info("Form reset to default");
//   };

//   // ─── Handlers: Fetch Users ────────────────────────────────────────────────
//   const fetchUsers = async () => {
//     try {
//       setFetching(true);
//       setVisiblePasswords({});
//       const response = await api.get("/getAllRegisteredUsers");
//       if (response.status === 200) {
//         setUsers(response.data?.data || []);
//         if ((response.data?.data || []).length === 0) {
//           toast.info("No registered users found.");
//         } else {
//           toast.success(`Loaded ${response.data.count} user(s)`);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching users:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch users.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   const handleViewChange = (newView) => {
//     setView(newView);
//     if (newView === "fetch") fetchUsers();
//   };

//   const togglePasswordVisibility = async (id) => {
//     if (visiblePasswords[id]) {
//       setVisiblePasswords((prev) => ({ ...prev, [id]: "" }));
//       return;
//     }

//     try {
//       const response = await api.get(`/getRegisteredUserPassword/${id}`);
//       setVisiblePasswords((prev) => ({
//         ...prev,
//         [id]: response.data?.password || "",
//       }));
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to reveal password.");
//     }
//   };

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ minHeight: "100vh", p: { xs: 2, md: 3 }, background: "#f5f7fa" }}>
//       <ToastContainer position="top-right" autoClose={3000} />

//       <MuiHeader header="User Register" />

//       {/* Top action bar */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3,
//           flexWrap: "wrap",
//           gap: 2,
//         }}
//       >
//         <Button
//           variant="outlined"
//           startIcon={<ArrowBackIcon />}
//           onClick={() => navigate("/")}
//           sx={{
//             textTransform: "none",
//             borderRadius: "8px",
//             borderColor: "#1976d2",
//             color: "#1976d2",
//             "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
//           }}
//         >
//           Back to Dashboard
//         </Button>

//         <Stack direction="row" spacing={1} alignItems="center">
//           <Chip
//             icon={<SuccessIcon />}
//             label="Local DB: mongodb://localhost:27017/"
//             color="primary"
//             variant="outlined"
//             size="small"
//           />
//         </Stack>
//       </Box>

//       {/* ── View Toggle Buttons ──────────────────────────────────────────── */}
//       <Box
//         sx={{
//           display: "flex",
//           gap: 2,
//           mb: 3,
//           maxWidth: 950,
//           mx: "auto",
//         }}
//       >
//         <Button
//           id="btn-create-user"
//           variant={view === "create" ? "contained" : "outlined"}
//           startIcon={<PersonAddIcon />}
//           onClick={() => setView("create")}
//           sx={{
//             flex: 1,
//             py: 1.3,
//             borderRadius: "10px",
//             textTransform: "none",
//             fontWeight: 700,
//             fontSize: "15px",
//             boxShadow: view === "create" ? "0 4px 14px rgba(25,118,210,0.35)" : "none",
//             backgroundColor: view === "create" ? "#1976d2" : "transparent",
//             borderColor: "#1976d2",
//             color: view === "create" ? "#fff" : "#1976d2",
//             "&:hover": {
//               backgroundColor: view === "create" ? "#1565c0" : "#e3f2fd",
//             },
//           }}
//         >
//           Create User
//         </Button>

//         <Button
//           id="btn-fetch-users"
//           variant={view === "fetch" ? "contained" : "outlined"}
//           startIcon={<GroupIcon />}
//           onClick={() => handleViewChange("fetch")}
//           sx={{
//             flex: 1,
//             py: 1.3,
//             borderRadius: "10px",
//             textTransform: "none",
//             fontWeight: 700,
//             fontSize: "15px",
//             boxShadow: view === "fetch" ? "0 4px 14px rgba(25,118,210,0.35)" : "none",
//             backgroundColor: view === "fetch" ? "#1976d2" : "transparent",
//             borderColor: "#1976d2",
//             color: view === "fetch" ? "#fff" : "#1976d2",
//             "&:hover": {
//               backgroundColor: view === "fetch" ? "#1565c0" : "#e3f2fd",
//             },
//           }}
//         >
//           Fetch Users
//         </Button>
//       </Box>

//       {/* ══════════════════════════════════════════════════════════════════
//           VIEW: CREATE USER
//       ══════════════════════════════════════════════════════════════════ */}
//       {view === "create" && (
//         <>
//           {/* Registration Form Card */}
//           <Card
//             sx={{
//               maxWidth: 950,
//               mx: "auto",
//               borderRadius: "16px",
//               boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
//               border: "1px solid #e0e6ed",
//               overflow: "hidden",
//               background: "#ffffff",
//             }}
//           >
//             {/* Card Header */}
//             <Box
//               sx={{
//                 background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
//                 color: "#ffffff",
//                 p: { xs: 2.5, md: 3 },
//               }}
//             >
//               <Box display="flex" alignItems="center" gap={2}>
//                 <Box
//                   sx={{
//                     width: 48,
//                     height: 48,
//                     borderRadius: "12px",
//                     backgroundColor: "rgba(255,255,255,0.2)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <HowToRegIcon sx={{ fontSize: 28, color: "#ffffff" }} />
//                 </Box>
//                 <Box>
//                   <Typography variant="h5" fontWeight="700" sx={{ letterSpacing: 0.5 }}>
//                     New User Registration
//                   </Typography>
//                   <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
//                     Fill in the required profile, credential, and contact details below
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             <CardContent sx={{ p: { xs: 3, md: 4 } }}>
//               <form onSubmit={handleSubmit} noValidate autoComplete="off">
//                 <Grid container spacing={3}>

//                   {/* User Name */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       User Name <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="username-input" name="username" autoComplete="off"
//                       inputProps={{ autoComplete: "off" }}
//                       placeholder="Enter full user name"
//                       value={formData.username} onChange={handleChange}
//                       error={Boolean(errors.username)} helperText={errors.username}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <PersonIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                       }}
//                       size="small"
//                     />
//                   </Grid>

//                   {/* User Type */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       User Type <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <FormControl fullWidth size="small" error={Boolean(errors.userType)}>
//                       <InputLabel id="user-type-label">Select User Type</InputLabel>
//                       <Select
//                         labelId="user-type-label" id="user-type-select"
//                         name="userType" value={formData.userType}
//                         label="Select User Type" onChange={handleChange}
//                         startAdornment={
//                           <InputAdornment position="start">
//                             <BadgeIcon sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }} />
//                           </InputAdornment>
//                         }
//                       >
//                         <MenuItem value="fellow">Fellow</MenuItem>
//                         <MenuItem value="anganwadi">Anganwadi</MenuItem>
//                         <MenuItem value="school">School</MenuItem>
//                         <MenuItem value="cci">CCI</MenuItem>
//                       </Select>
//                       {errors.userType && <FormHelperText>{errors.userType}</FormHelperText>}
//                     </FormControl>
//                   </Grid>

//                   {/* Email ID */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Email ID <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="email-input" name="email" type="email"
//                       autoComplete="off" inputProps={{ autoComplete: "off" }}
//                       placeholder="Enter email ID"
//                       value={formData.email} onChange={handleChange}
//                       error={Boolean(errors.email)} helperText={errors.email}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <MailIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                       }}
//                       size="small"
//                     />
//                   </Grid>

//                   {/* Password */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Password <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="password-input" name="password"
//                       type={showPassword ? "text" : "password"}
//                       autoComplete="new-password" inputProps={{ autoComplete: "new-password" }}
//                       placeholder="Min 8 chars, letter + digit + special char"
//                       value={formData.password} onChange={handleChange}
//                       error={Boolean(errors.password)} helperText={errors.password}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <LockIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton
//                               onClick={() => setShowPassword((v) => !v)}
//                               edge="end" size="small"
//                             >
//                               {showPassword ? <VisibilityOff /> : <Visibility />}
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                       size="small"
//                     />
//                   </Grid>

//                   {/* Status */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Status <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <FormControl fullWidth size="small" error={Boolean(errors.status)}>
//                       <InputLabel id="status-label">Select Status</InputLabel>
//                       <Select
//                         labelId="status-label" id="status-select"
//                         name="status" value={formData.status}
//                         label="Select Status" onChange={handleChange}
//                       >
//                         <MenuItem value="Inactive">Inactive</MenuItem>
//                         <MenuItem value="Active">Active</MenuItem>
//                       </Select>
//                       {errors.status && <FormHelperText>{errors.status}</FormHelperText>}
//                     </FormControl>
//                   </Grid>

//                   {/* Gender */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Gender <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <FormControl fullWidth size="small" error={Boolean(errors.gender)}>
//                       <InputLabel id="gender-label">Select Gender</InputLabel>
//                       <Select
//                         labelId="gender-label" id="gender-select"
//                         name="gender" value={formData.gender}
//                         label="Select Gender" onChange={handleChange}
//                         startAdornment={
//                           <InputAdornment position="start">
//                             <GenderIcon sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }} />
//                           </InputAdornment>
//                         }
//                       >
//                         <MenuItem value="Male">Male</MenuItem>
//                         <MenuItem value="Female">Female</MenuItem>
//                         <MenuItem value="Other">Other</MenuItem>
//                       </Select>
//                       {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
//                     </FormControl>
//                   </Grid>

//                   {/* Date of Birth */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Date of Birth <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="dob-input" name="dob" type="date"
//                       value={formData.dob} onChange={handleChange}
//                       error={Boolean(errors.dob)} helperText={errors.dob}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <CalendarIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                       }}
//                       InputLabelProps={{ shrink: true }}
//                       size="small"
//                     />
//                   </Grid>

//                   {/* Contact Number */}
//                   <Grid item xs={12} sm={6}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Contact Number <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="contact-input" name="contactNumber"
//                       inputProps={{ autoComplete: "off", maxLength: 10 }}
//                       placeholder="Enter 10-digit mobile number"
//                       value={formData.contactNumber} onChange={handleChange}
//                       error={Boolean(errors.contactNumber)} helperText={errors.contactNumber}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <PhoneIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                       }}
//                       size="small"
//                     />
//                   </Grid>

//                   {/* Permanent Address */}
//                   <Grid item xs={12}>
//                     <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
//                       Permanent Address <span style={{ color: "#d32f2f" }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth id="address-input" name="permanentAddress"
//                       multiline rows={3} inputProps={{ autoComplete: "off" }}
//                       placeholder="Enter full permanent address"
//                       value={formData.permanentAddress} onChange={handleChange}
//                       error={Boolean(errors.permanentAddress)}
//                       helperText={errors.permanentAddress}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.2 }}>
//                             <HomeIcon sx={{ color: "#1976d2" }} />
//                           </InputAdornment>
//                         ),
//                       }}
//                       size="small"
//                     />
//                   </Grid>
//                 </Grid>

//                 <Divider sx={{ my: 4 }} />

//                 {/* Action Buttons */}
//                 <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, flexWrap: "wrap" }}>
//                   <Button
//                     type="button" variant="outlined" color="secondary"
//                     startIcon={<ResetIcon />} onClick={handleReset}
//                     sx={{ px: 3, py: 1, borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
//                   >
//                     Reset
//                   </Button>
//                   <Button
//                     type="submit" variant="contained" disabled={submitting}
//                     startIcon={submitting ? <CircularProgress size={20} color="inherit" /> : <HowToRegIcon />}
//                     sx={{
//                       px: 4, py: 1, borderRadius: "8px",
//                       backgroundColor: "#1976d2",
//                       "&:hover": { backgroundColor: "#1565c0" },
//                       textTransform: "none", fontWeight: 600,
//                       boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                     }}
//                   >
//                     {submitting ? "Registering..." : "Register User"}
//                   </Button>
//                 </Box>
//               </form>
//             </CardContent>
//           </Card>

//           {/* Latest Submission Preview */}
//           {submittedData && (
//             <Paper
//               elevation={2}
//               sx={{
//                 maxWidth: 950, mx: "auto", mt: 4, p: 3,
//                 borderRadius: "12px",
//                 border: "1px solid #c8e6c9",
//                 backgroundColor: "#f1f8e9",
//               }}
//             >
//               <Box display="flex" alignItems="center" gap={1.5} mb={2}>
//                 <SuccessIcon color="success" />
//                 <Typography variant="h6" fontWeight={700} color="#2e7d32">
//                   Latest Submission Preview (User Record)
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">User Name</Typography>
//                   <Typography variant="body1" fontWeight={600}>{submittedData.username}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">User Type</Typography>
//                   <Typography variant="body1" fontWeight={600}>{submittedData.userType}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Status</Typography>
//                   <Box>
//                     <Chip
//                       label={submittedData.status}
//                       color={submittedData.status === "Active" ? "success" : "default"}
//                       size="small"
//                     />
//                   </Box>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Email ID</Typography>
//                   <Typography variant="body2">{submittedData.email}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">User ID</Typography>
//                   <Typography variant="body2" fontWeight={600} sx={{ color: "#1565c0", wordBreak: "break-all" }}>
//                     {submittedData.email.trim().toLowerCase()}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Password</Typography>
//                   <Box display="flex" alignItems="center" gap={0.5}>
//                     <Typography
//                       variant="body2" fontWeight={600}
//                       sx={{ fontFamily: "monospace", letterSpacing: showPreviewPassword ? 0 : 2 }}
//                     >
//                       {showPreviewPassword
//                         ? submittedData.plainPassword
//                         : "•".repeat(submittedData.plainPassword?.length || 8)}
//                     </Typography>
//                     <IconButton
//                       size="small"
//                       onClick={() => setShowPreviewPassword((v) => !v)}
//                       sx={{ color: "#1976d2", p: 0.3 }}
//                     >
//                       {showPreviewPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                     </IconButton>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Gender</Typography>
//                   <Typography variant="body2">{submittedData.gender}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Date of Birth</Typography>
//                   <Typography variant="body2">{submittedData.dob}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography variant="caption" color="text.secondary">Contact Number</Typography>
//                   <Typography variant="body2">{submittedData.contactNumber}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={8}>
//                   <Typography variant="caption" color="text.secondary">Permanent Address</Typography>
//                   <Typography variant="body2">{submittedData.permanentAddress}</Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           )}
//         </>
//       )}

//       {/* ══════════════════════════════════════════════════════════════════
//           VIEW: FETCH USERS
//       ══════════════════════════════════════════════════════════════════ */}
//       {view === "fetch" && (
//         <Box sx={{ maxWidth: 1200, mx: "auto" }}>
//           {/* Header row */}
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Typography variant="h6" fontWeight={700} color="#1565c0">
//               Registered Users
//             </Typography>
//             <Button
//               id="btn-refresh-users"
//               variant="outlined"
//               startIcon={fetching ? <CircularProgress size={16} /> : <RefreshIcon />}
//               onClick={fetchUsers}
//               disabled={fetching}
//               sx={{
//                 textTransform: "none", borderRadius: "8px",
//                 borderColor: "#1976d2", color: "#1976d2",
//                 "&:hover": { backgroundColor: "#e3f2fd" },
//               }}
//             >
//               {fetching ? "Loading..." : "Refresh"}
//             </Button>
//           </Box>

//           {fetching ? (
//             <Box display="flex" justifyContent="center" alignItems="center" py={8}>
//               <CircularProgress />
//               <Typography ml={2} color="text.secondary">Fetching users...</Typography>
//             </Box>
//           ) : users.length === 0 ? (
//             <Paper
//               sx={{
//                 p: 5, textAlign: "center", borderRadius: "12px",
//                 border: "1px dashed #b0bec5", backgroundColor: "#fafafa",
//               }}
//             >
//               <GroupIcon sx={{ fontSize: 56, color: "#b0bec5", mb: 1 }} />
//               <Typography variant="h6" color="text.secondary">No Users Found</Typography>
//               <Typography variant="body2" color="text.secondary" mt={0.5}>
//                 Register users using Create User, then refresh.
//               </Typography>
//             </Paper>
//           ) : (
//             <TableContainer
//               component={Paper}
//               sx={{ borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.07)", overflow: "auto" }}
//             >
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow sx={{ "& th": { backgroundColor: "#1976d2", color: "#fff", fontWeight: 700, fontSize: "13px" } }}>
//                     <TableCell>#</TableCell>
//                     <TableCell>User Name</TableCell>
//                     <TableCell>User ID</TableCell>
//                     <TableCell>Email ID</TableCell>
//                     <TableCell>Password (Hashed)</TableCell>
//                     <TableCell>User Type</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell>Gender</TableCell>
//                     <TableCell>Date of Birth</TableCell>
//                     <TableCell>Contact</TableCell>
//                     <TableCell>Address</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {users.map((user, idx) => (
//                     <TableRow
//                       key={user._id}
//                       sx={{
//                         "&:hover": { backgroundColor: "#e3f2fd" },
//                         backgroundColor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
//                       }}
//                     >
//                       <TableCell sx={{ color: "#9e9e9e", fontWeight: 600 }}>{idx + 1}</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>{user.username}</TableCell>
//                       <TableCell sx={{ color: "#1565c0", fontWeight: 600, fontSize: "12px" }}>
//                         {user.userId}
//                       </TableCell>
//                       <TableCell sx={{ fontSize: "12px" }}>{user.email}</TableCell>
//                       <TableCell>
//                         <Box display="flex" alignItems="center" gap={0.5}>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               fontFamily: "monospace",
//                               fontSize: "11px",
//                               maxWidth: visiblePasswords[user._id] ? 420 : 90,
//                               overflow: visiblePasswords[user._id] ? "visible" : "hidden",
//                               textOverflow: visiblePasswords[user._id] ? "clip" : "ellipsis",
//                               whiteSpace: visiblePasswords[user._id] ? "normal" : "nowrap",
//                               overflowWrap: visiblePasswords[user._id] ? "anywhere" : "normal",
//                               letterSpacing: visiblePasswords[user._id] ? 0 : 1.5,
//                               color: visiblePasswords[user._id] ? "#37474f" : "#90a4ae",
//                             }}
//                           >
//                             {visiblePasswords[user._id] || "•".repeat(12)}
//                           </Typography>
//                           <Tooltip title={visiblePasswords[user._id] ? "Hide hash" : "Show hash"}>
//                             <IconButton
//                               size="small"
//                               onClick={() => togglePasswordVisibility(user._id)}
//                               sx={{ color: "#1976d2", p: 0.3 }}
//                             >
//                               {visiblePasswords[user._id]
//                                 ? <VisibilityOff sx={{ fontSize: 15 }} />
//                                 : <Visibility sx={{ fontSize: 15 }} />}
//                             </IconButton>
//                           </Tooltip>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Chip label={user.userType} size="small" variant="outlined" color="primary" />
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={user.status}
//                           size="small"
//                           color={user.status === "Active" ? "success" : "default"}
//                         />
//                       </TableCell>
//                       <TableCell>{user.gender}</TableCell>
//                       <TableCell sx={{ whiteSpace: "nowrap" }}>{user.dob}</TableCell>
//                       <TableCell sx={{ whiteSpace: "nowrap" }}>{user.contactNumber}</TableCell>
//                       <TableCell
//                         sx={{
//                           maxWidth: 160, overflow: "hidden",
//                           textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "12px",
//                         }}
//                       >
//                         <Tooltip title={user.permanentAddress} placement="top">
//                           <span>{user.permanentAddress}</span>
//                         </Tooltip>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}

//           {users.length > 0 && (
//             <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
//               Total: {users.length} user(s) · Click the eye to reveal a password
//             </Typography>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// }

// export default UserRegister;

// ..........................

import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MuiHeader from "../../components/MuiHeader";
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Divider,
  Paper,
  Chip,
  FormHelperText,
  Stack,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  EditOutlined as EditIcon,
  DeleteOutline as DeleteIcon,
  Save as SaveIcon,
  PersonOutline as PersonIcon,
  MailOutline as MailIcon,
  LockOutlined as LockIcon,
  PhoneOutlined as PhoneIcon,
  HomeOutlined as HomeIcon,
  CalendarTodayOutlined as CalendarIcon,
  BadgeOutlined as BadgeIcon,
  WcOutlined as GenderIcon,
  Visibility,
  VisibilityOff,
  ArrowBack as ArrowBackIcon,
  HowToReg as HowToRegIcon,
  RestartAlt as ResetIcon,
  CheckCircleOutline as SuccessIcon,
  PersonAdd as PersonAddIcon,
  Group as GroupIcon,
  Refresh as RefreshIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bcrypt from "bcryptjs";
import api from "../../api/api";

const initialFormState = {
  username: "",
  userType: "",
  email: "",
  password: "",
  status: "Active",
  gender: "",
  dob: "",
  contactNumber: "",
  permanentAddress: "",
};

const USERS_PAGE_SIZE = 50; // must match the backend page size

const getPasswordError = (password) => {
  if (!password) return "Password is required";
  if (password.length < 8) return "Password must be at least 8 characters";
  if (!/[a-zA-Z]/.test(password))
    return "Password must include at least one letter";
  if (!/[0-9]/.test(password)) return "Password must include at least one digit";
  if (!/[@_!#$%^&*(),.?":{}|<>\-]/.test(password))
    return "Password must include at least one special character (@, _, !, # etc.)";
  return "";
};

// Backend stores gender lowercase ("male" | "female" | "others"); the form uses "Male" | "Female" | "Other"
const toFormGender = (gender = "") => {
  const g = gender.toLowerCase();
  if (g === "male") return "Male";
  if (g === "female") return "Female";
  if (g === "other" || g === "others") return "Other";
  return "";
};

function UserRegister() {
  const navigate = useNavigate();
  const [view, setView] = useState("create"); // "create" | "fetch"

  // ─── Create User state ───────────────────────────────────────────────────
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPreviewPassword, setShowPreviewPassword] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // ─── Fetch Users state ────────────────────────────────────────────────────
  const [users, setUsers] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [visiblePasswords, setVisiblePasswords] = useState({}); // { [userId]: bool }
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  // Pages already fetched, keyed by page number. Previous reuses these without an API call.
  const pageCache = useRef({});

  // ─── Edit User state ──────────────────────────────────────────────────────
  const [editUserId, setEditUserId] = useState(null); // dialog is open when set
  const [editData, setEditData] = useState(initialFormState);
  const [editErrors, setEditErrors] = useState({});
  const [originalPassword, setOriginalPassword] = useState("");
  const [showEditPassword, setShowEditPassword] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);

  // ─── Handlers: Create User ────────────────────────────────────────────────
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   if (errors[name]) {
  //     setErrors((prev) => ({ ...prev, [name]: "" }));
  //   }
  // };

  const handleChange = (e) => {
    let { name, value } = e.target;

    // Contact number: sirf digits allowed, max 10
    if (name === "contactNumber") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    // Password: max 15 characters
    if (name === "password") {
      value = value.slice(0, 15);
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = "User Name is required";
    if (!formData.userType) newErrors.userType = "Please select a User Type";
    if (!formData.email.trim()) {
      newErrors.email = "Email ID is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      newErrors.email = "Please enter a valid email address";
    }
    const passwordError = getPasswordError(formData.password);
    if (passwordError) newErrors.password = passwordError;
    if (!formData.status) newErrors.status = "Please select a Status";
    if (!formData.gender) newErrors.gender = "Please select Gender";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!formData.contactNumber.trim()) {
      newErrors.contactNumber = "Contact Number is required";
    } else if (!/^[0-9]{10}$/.test(formData.contactNumber.trim())) {
      newErrors.contactNumber = "Please enter a valid 10-digit contact number";
    }
    if (!formData.permanentAddress.trim()) {
      newErrors.permanentAddress = "Permanent Address is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("Please fill all required fields correctly!");
      return;
    }
    try {
      setSubmitting(true);
      const plainPassword = formData.password;

      // Hash password on frontend before sending to backend
      const saltRounds = 10;
      const hashedPassword = await bcrypt.hash(plainPassword, saltRounds);

      const payload = {
        ...formData,
        password: hashedPassword,
        recoveryPassword: plainPassword,
      };
      const response = await api.post("/registerUser", payload);

      if (response.status === 200 || response.status === 201) {
        setSubmittedData({ ...formData, plainPassword });
        setFormData(initialFormState);
        setErrors({});
        setShowPreviewPassword(false);

        Swal.fire({
          icon: "success",
          title: "User Registered Successfully!",
          html: `
            <div style="text-align: left; font-size: 14px; line-height: 1.6; padding: 10px; background: #f8fafc; border-radius: 8px;">
             
              <hr style="border: none; border-top: 1px solid #e2e8f0; margin-bottom: 10px;" />
              <p><strong>User Name:</strong> ${formData.username}</p>
              <p><strong>User Type:</strong> ${formData.userType}</p>
              <p><strong>Email ID:</strong> ${formData.email}</p>
              <p><strong>User ID:</strong> <span style="color: #1565c0; font-weight: 600;">${formData.email.trim().toLowerCase()}</span></p>
              <p><strong>Password:</strong> <span style="background: #fff3e0; padding: 2px 8px; border-radius: 4px; font-family: monospace; font-weight: 600; color: #e65100;">${plainPassword}</span></p>
              <p><strong>Status:</strong> ${formData.status}</p>
              <p><strong>Gender:</strong> ${formData.gender}</p>
              <p><strong>Date of Birth:</strong> ${formData.dob}</p>
              <p><strong>Contact:</strong> ${formData.contactNumber}</p>
              <p><strong>Address:</strong> ${formData.permanentAddress}</p>
            </div>
          `,
          confirmButtonText: "Done",
          confirmButtonColor: "#1976d2",
        });

        toast.success(
          response.data?.message ||
            "User registered successfully in local MongoDB!",
        );
      } else {
        toast.error("Failed to register user. Please try again.");
      }
    } catch (err) {
      console.error("Error registering user:", err);
      const errorMsg =
        err.response?.data?.message ||
        err.message ||
        "Failed to register user. Please ensure local server is running.";
      toast.error(errorMsg);
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: errorMsg,
        confirmButtonColor: "#d32f2f",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setFormData(initialFormState);
    setErrors({});
    setSubmittedData(null);
    toast.info("Form reset to default");
  };

  // ─── Handlers: Fetch Users ────────────────────────────────────────────────
  const fetchUsers = async (pageNumber = 1) => {
    try {
      setFetching(true);
      setVisiblePasswords({});
      const response = await api.get("/getAllRegisteredUsers", {
        params: { page: pageNumber },
      });
      if (response.status === 200) {
        const data = response.data?.data || [];
        const fetchedPage = response.data?.page || pageNumber;
        pageCache.current[fetchedPage] = data;
        setUsers(data);
        setPage(fetchedPage);
        setTotalPages(response.data?.totalPages || 1);
        setTotalUsers(response.data?.total || 0);
        if (data.length === 0) {
          toast.info("No registered users found.");
        } else {
          toast.success(`Loaded ${data.length} user(s)`);
        }
      }
    } catch (err) {
      console.error("Error fetching users:", err);
      toast.error(err.response?.data?.message || "Failed to fetch users.");
    } finally {
      setFetching(false);
    }
  };

  const handleViewChange = (newView) => {
    setView(newView);
    if (newView === "fetch") {
      pageCache.current = {};
      fetchUsers(1);
    }
  };

  const handleRefresh = () => {
    pageCache.current = {};
    fetchUsers(page);
  };

  const showCachedPage = (pageNumber) => {
    setUsers(pageCache.current[pageNumber]);
    setPage(pageNumber);
    setVisiblePasswords({});
  };

  // Show a page from the cache when it was fetched before; call the API only for unseen pages
  const goToPage = (pageNumber) => {
    if (pageCache.current[pageNumber]) {
      showCachedPage(pageNumber);
    } else {
      fetchUsers(pageNumber);
    }
  };

  // Eye button: fetches the ORIGINAL (decrypted) password from backend on demand
  const togglePasswordVisibility = async (id) => {
    if (visiblePasswords[id]) {
      setVisiblePasswords((prev) => ({ ...prev, [id]: "" }));
      return;
    }

    try {
      const response = await api.get(`/getRegisteredUserPassword/${id}`);
      setVisiblePasswords((prev) => ({
        ...prev,
        [id]: response.data?.password || "",
      }));
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Original password not available for this user (old user?).",
      );
    }
  };

  // ─── Handlers: Delete User ────────────────────────────────────────────────
  const handleDeleteUser = async (user) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Delete User?",
      html: `Are you sure you want to delete <strong>${user.username}</strong> (${user.emailid})?<br/>This cannot be undone.`,
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d32f2f",
    });
    if (!result.isConfirmed) return;

    try {
      const response = await api.delete(`/deleteRegisteredUser/${user._id}`);
      toast.success(response.data?.message || "User deleted successfully.");
      // Users after this page shift back by one, so drop their cached pages. Earlier pages stay valid.
      Object.keys(pageCache.current).forEach((key) => {
        if (Number(key) >= page) delete pageCache.current[key];
      });
      // Reload the current page so totals stay correct; step back if this page is now empty
      const isLastOnPage = users.length === 1 && page > 1;
      fetchUsers(isLastOnPage ? page - 1 : page);
    } catch (err) {
      console.error("Error deleting user:", err);
      toast.error(err.response?.data?.message || "Failed to delete user.");
    }
  };

  // ─── Handlers: Edit User ──────────────────────────────────────────────────
  const openEditDialog = async (user) => {
    setEditData({
      username: user.username || "",
      userType: user.usertype || "",
      email: user.emailid || "",
      password: "",
      status: user.status || "",
      gender: toFormGender(user.gender),
      dob: user.dob ? String(user.dob).slice(0, 10) : "",
      contactNumber: user.contactnumber || "",
      permanentAddress: user.permanentaddress || "",
    });
    setEditErrors({});
    setOriginalPassword("");
    setShowEditPassword(false);
    setEditUserId(user._id);

    // Pre-fill the current password from the recovery copy, if one exists
    try {
      const response = await api.get(`/getRegisteredUserPassword/${user._id}`);
      const current = response.data?.password || "";
      setOriginalPassword(current);
      setEditData((prev) => ({ ...prev, password: current }));
    } catch (err) {
      // Older users may not have a recovery password; leaving it blank keeps the existing one
    }
  };

  const closeEditDialog = () => {
    if (savingEdit) return;
    setEditUserId(null);
  };

  const handleEditChange = (e) => {
    let { name, value } = e.target;
    if (name === "contactNumber") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }
    if (name === "password") {
      value = value.slice(0, 15);
    }
    setEditData((prev) => ({ ...prev, [name]: value }));
    if (editErrors[name]) {
      setEditErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const passwordChanged = editData.password !== originalPassword;

  const validateEdit = () => {
    const newErrors = {};
    if (!editData.username.trim()) newErrors.username = "User Name is required";
    if (!editData.userType) newErrors.userType = "Please select a User Type";
    // Blank password is allowed only when there was no recovery password to pre-fill (keeps existing)
    if (passwordChanged && (editData.password || originalPassword)) {
      const passwordError = getPasswordError(editData.password);
      if (passwordError) newErrors.password = passwordError;
    }
    if (!editData.gender) newErrors.gender = "Please select Gender";
    if (!editData.dob) newErrors.dob = "Date of Birth is required";
    if (!/^[0-9]{10}$/.test(editData.contactNumber.trim())) {
      newErrors.contactNumber = "Please enter a valid 10-digit contact number";
    }
    if (!editData.permanentAddress.trim()) {
      newErrors.permanentAddress = "Permanent Address is required";
    }
    setEditErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateEdit()) {
      toast.error("Please fill all required fields correctly!");
      return;
    }
    try {
      setSavingEdit(true);
      // Email ID and Status are read-only and intentionally not sent
      const payload = {
        username: editData.username,
        userType: editData.userType,
        gender: editData.gender,
        dob: editData.dob,
        contactNumber: editData.contactNumber,
        permanentAddress: editData.permanentAddress,
      };
      if (passwordChanged && editData.password) {
        payload.password = await bcrypt.hash(editData.password, 10);
        payload.recoveryPassword = editData.password;
      }

      const response = await api.put(
        `/updateRegisteredUser/${editUserId}`,
        payload,
      );
      const updated = response.data?.data;
      if (updated) {
        const replaceUser = (list) =>
          list.map((u) => (u._id === updated._id ? updated : u));
        Object.keys(pageCache.current).forEach((key) => {
          pageCache.current[key] = replaceUser(pageCache.current[key]);
        });
        setUsers(replaceUser);
      }
      // Drop any revealed password for this user so the table doesn't show a stale value
      setVisiblePasswords((prev) => ({ ...prev, [editUserId]: "" }));
      setEditUserId(null);
      toast.success(response.data?.message || "User updated successfully.");
    } catch (err) {
      console.error("Error updating user:", err);
      toast.error(err.response?.data?.message || "Failed to update user.");
    } finally {
      setSavingEdit(false);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <Box
      sx={{ minHeight: "100vh", p: { xs: 2, md: 3 }, background: "#f5f7fa" }}
    >
      <ToastContainer position="top-right" autoClose={3000} />

      <MuiHeader header="User Register" />

      {/* Top action bar */}
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/")}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            borderColor: "#1976d2",
            color: "#1976d2",
            "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
          }}
        >
          Back to Dashboard
        </Button>

      
      </Box> */}

      {/* ── View Toggle Buttons ──────────────────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          maxWidth: 950,
          mx: "auto",
        }}
      >
        <Button
          id="btn-create-user"
          variant={view === "create" ? "contained" : "outlined"}
          startIcon={<PersonAddIcon />}
          onClick={() => setView("create")}
          sx={{
            flex: 1,
            py: 1.3,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "15px",
            boxShadow:
              view === "create" ? "0 4px 14px rgba(25,118,210,0.35)" : "none",
            backgroundColor: view === "create" ? "#1976d2" : "transparent",
            borderColor: "#1976d2",
            color: view === "create" ? "#fff" : "#1976d2",
            "&:hover": {
              backgroundColor: view === "create" ? "#1565c0" : "#e3f2fd",
            },
          }}
        >
          Create User
        </Button>

        <Button
          id="btn-fetch-users"
          variant={view === "fetch" ? "contained" : "outlined"}
          startIcon={<GroupIcon />}
          onClick={() => handleViewChange("fetch")}
          sx={{
            flex: 1,
            py: 1.3,
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "15px",
            boxShadow:
              view === "fetch" ? "0 4px 14px rgba(25,118,210,0.35)" : "none",
            backgroundColor: view === "fetch" ? "#1976d2" : "transparent",
            borderColor: "#1976d2",
            color: view === "fetch" ? "#fff" : "#1976d2",
            "&:hover": {
              backgroundColor: view === "fetch" ? "#1565c0" : "#e3f2fd",
            },
          }}
        >
          Fetch Users
        </Button>
      </Box>

      {/* ══════════════════════════════════════════════════════════════════
          VIEW: CREATE USER
      ══════════════════════════════════════════════════════════════════ */}
      {view === "create" && (
        <>
          {/* Registration Form Card */}
          <Card
            sx={{
              maxWidth: 950,
              mx: "auto",
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              border: "1px solid #e0e6ed",
              overflow: "hidden",
              background: "#ffffff",
            }}
          >
            {/* Card Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                color: "#ffffff",
                p: { xs: 2.5, md: 3 },
              }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "12px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <HowToRegIcon sx={{ fontSize: 28, color: "#ffffff" }} />
                </Box>
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    sx={{ letterSpacing: 0.5 }}
                  >
                    New User Registration
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                    Fill in the required profile, credential, and contact
                    details below
                  </Typography>
                </Box>
              </Box>
            </Box>

            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
              <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  {/* User Name */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      User Name <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="username-input"
                      name="username"
                      autoComplete="off"
                      inputProps={{ autoComplete: "off" }}
                      placeholder="Enter full user name"
                      value={formData.username}
                      onChange={handleChange}
                      error={Boolean(errors.username)}
                      helperText={errors.username}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>

                  {/* User Type */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      User Type <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <FormControl
                      fullWidth
                      size="small"
                      error={Boolean(errors.userType)}
                    >
                      <InputLabel id="user-type-label">
                        Select User Type
                      </InputLabel>
                      <Select
                        labelId="user-type-label"
                        id="user-type-select"
                        name="userType"
                        value={formData.userType}
                        label="Select User Type"
                        onChange={handleChange}
                        startAdornment={
                          <InputAdornment position="start">
                            <BadgeIcon
                              sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }}
                            />
                          </InputAdornment>
                        }
                      >
                        <MenuItem value="fellow">Fellow</MenuItem>
                        <MenuItem value="anganwadi">Anganwadi</MenuItem>
                        <MenuItem value="school">School</MenuItem>
                        <MenuItem value="cci">CCI</MenuItem>
                      </Select>
                      {errors.userType && (
                        <FormHelperText>{errors.userType}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Email ID */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Email ID <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="email-input"
                      name="email"
                      type="email"
                      autoComplete="off"
                      inputProps={{ autoComplete: "off" }}
                      placeholder="Enter email ID"
                      value={formData.email}
                      onChange={handleChange}
                      error={Boolean(errors.email)}
                      helperText={errors.email}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MailIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>

                  {/* Password */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Password <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="password-input"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="new-password"
                      inputProps={{ autoComplete: "new-password" }}
                      placeholder="Min 8 chars, letter + digit + special char"
                      value={formData.password}
                      onChange={handleChange}
                      error={Boolean(errors.password)}
                      helperText={errors.password}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((v) => !v)}
                              edge="end"
                              size="small"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>

                  {/* Status */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Status <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <FormControl
                      fullWidth
                      size="small"
                      error={Boolean(errors.status)}
                    >
                      <InputLabel id="status-label">Select Status</InputLabel>
                      <Select
                        labelId="status-label"
                        id="status-select"
                        name="status"
                        value={formData.status}
                        label="Select Status"
                        onChange={handleChange}
                      >
                        <MenuItem value="Inactive">Inactive</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                      </Select>
                      {errors.status && (
                        <FormHelperText>{errors.status}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Gender */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Gender <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <FormControl
                      fullWidth
                      size="small"
                      error={Boolean(errors.gender)}
                    >
                      <InputLabel id="gender-label">Select Gender</InputLabel>
                      <Select
                        labelId="gender-label"
                        id="gender-select"
                        name="gender"
                        value={formData.gender}
                        label="Select Gender"
                        onChange={handleChange}
                        startAdornment={
                          <InputAdornment position="start">
                            <GenderIcon
                              sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }}
                            />
                          </InputAdornment>
                        }
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      {errors.gender && (
                        <FormHelperText>{errors.gender}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Date of Birth */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Date of Birth <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="dob-input"
                      name="dob"
                      type="date"
                      value={formData.dob}
                      onChange={handleChange}
                      error={Boolean(errors.dob)}
                      helperText={errors.dob}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalendarIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                  </Grid>

                  {/* Contact Number */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Contact Number <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="contact-input"
                      name="contactNumber"
                      inputProps={{ autoComplete: "off", maxLength: 10 }}
                      placeholder="Enter 10-digit mobile number"
                      value={formData.contactNumber}
                      onChange={handleChange}
                      error={Boolean(errors.contactNumber)}
                      helperText={errors.contactNumber}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>

                  {/* Permanent Address */}
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      mb={1}
                      color="#374151"
                    >
                      Permanent Address{" "}
                      <span style={{ color: "#d32f2f" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      id="address-input"
                      name="permanentAddress"
                      multiline
                      rows={3}
                      inputProps={{ autoComplete: "off" }}
                      placeholder="Enter full permanent address"
                      value={formData.permanentAddress}
                      onChange={handleChange}
                      error={Boolean(errors.permanentAddress)}
                      helperText={errors.permanentAddress}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            sx={{ alignSelf: "flex-start", mt: 1.2 }}
                          >
                            <HomeIcon sx={{ color: "#1976d2" }} />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 4 }} />

                {/* Action Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<ResetIcon />}
                    onClick={handleReset}
                    sx={{
                      px: 3,
                      py: 1,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    startIcon={
                      submitting ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <HowToRegIcon />
                      )
                    }
                    sx={{
                      px: 4,
                      py: 1,
                      borderRadius: "8px",
                      backgroundColor: "#1976d2",
                      "&:hover": { backgroundColor: "#1565c0" },
                      textTransform: "none",
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                    }}
                  >
                    {submitting ? "Registering..." : "Register User"}
                  </Button>
                </Box>
              </form>
            </CardContent>
          </Card>

          {/* Latest Submission Preview */}
          {submittedData && (
            <Paper
              elevation={2}
              sx={{
                maxWidth: 950,
                mx: "auto",
                mt: 4,
                p: 3,
                borderRadius: "12px",
                border: "1px solid #c8e6c9",
                backgroundColor: "#f1f8e9",
              }}
            >
              <Box display="flex" alignItems="center" gap={1.5} mb={2}>
                <SuccessIcon color="success" />
                <Typography variant="h6" fontWeight={700} color="#2e7d32">
                  Latest Submission Preview (User Record)
                </Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    User Name
                  </Typography>
                  <Typography variant="body1" fontWeight={600}>
                    {submittedData.username}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    User Type
                  </Typography>
                  <Typography variant="body1" fontWeight={600}>
                    {submittedData.userType}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Status
                  </Typography>
                  <Box>
                    <Chip
                      label={submittedData.status}
                      color={
                        submittedData.status === "Active"
                          ? "success"
                          : "default"
                      }
                      size="small"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Email ID
                  </Typography>
                  <Typography variant="body2">{submittedData.email}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    User ID
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ color: "#1565c0", wordBreak: "break-all" }}
                  >
                    {submittedData.email.trim().toLowerCase()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Password
                  </Typography>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={{
                        fontFamily: "monospace",
                        letterSpacing: showPreviewPassword ? 0 : 2,
                      }}
                    >
                      {showPreviewPassword
                        ? submittedData.plainPassword
                        : "•".repeat(submittedData.plainPassword?.length || 8)}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => setShowPreviewPassword((v) => !v)}
                      sx={{ color: "#1976d2", p: 0.3 }}
                    >
                      {showPreviewPassword ? (
                        <VisibilityOff fontSize="small" />
                      ) : (
                        <Visibility fontSize="small" />
                      )}
                    </IconButton>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Gender
                  </Typography>
                  <Typography variant="body2">
                    {submittedData.gender}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Date of Birth
                  </Typography>
                  <Typography variant="body2">{submittedData.dob}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary">
                    Contact Number
                  </Typography>
                  <Typography variant="body2">
                    {submittedData.contactNumber}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="caption" color="text.secondary">
                    Permanent Address
                  </Typography>
                  <Typography variant="body2">
                    {submittedData.permanentAddress}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
        </>
      )}

      {/* ══════════════════════════════════════════════════════════════════
          VIEW: FETCH USERS
      ══════════════════════════════════════════════════════════════════ */}
      {view === "fetch" && (
        <Box sx={{ maxWidth: 1500, mx: "auto" }}>
          {/* Header row */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" fontWeight={700} color="#1565c0">
              Registered Users
            </Typography>
            <Button
              id="btn-refresh-users"
              variant="outlined"
              startIcon={
                fetching ? <CircularProgress size={16} /> : <RefreshIcon />
              }
              onClick={handleRefresh}
              disabled={fetching}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                borderColor: "#1976d2",
                color: "#1976d2",
                "&:hover": { backgroundColor: "#e3f2fd" },
              }}
            >
              {fetching ? "Loading..." : "Refresh"}
            </Button>
          </Box>

          {fetching ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={8}
            >
              <CircularProgress />
              <Typography ml={2} color="text.secondary">
                Fetching users...
              </Typography>
            </Box>
          ) : users.length === 0 ? (
            <Paper
              sx={{
                p: 5,
                textAlign: "center",
                borderRadius: "12px",
                border: "1px dashed #b0bec5",
                backgroundColor: "#fafafa",
              }}
            >
              <GroupIcon sx={{ fontSize: 56, color: "#b0bec5", mb: 1 }} />
              <Typography variant="h6" color="text.secondary">
                No Users Found
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                Register users using Create User, then refresh.
              </Typography>
            </Paper>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
                overflow: "auto",
              }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "13px",
                      },
                    }}
                  >
                    <TableCell>#</TableCell>
                    <TableCell>User Name</TableCell>
                    <TableCell>User ID</TableCell>
                    <TableCell>Email ID</TableCell>
                    <TableCell>Password</TableCell>
                    <TableCell>User Type</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell>Date of Birth</TableCell>
                    <TableCell>Contact</TableCell>
                    <TableCell>Address</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user, idx) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:hover": { backgroundColor: "#e3f2fd" },
                        backgroundColor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                      }}
                    >
                      <TableCell sx={{ color: "#9e9e9e", fontWeight: 600 }}>
                        {(page - 1) * USERS_PAGE_SIZE + idx + 1}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {user.username}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#1565c0",
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      >
                        {user.userid}
                      </TableCell>
                      <TableCell sx={{ fontSize: "12px" }}>
                        {user.emailid}
                      </TableCell>
                      <TableCell>
                        {user.hasPassword && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontFamily: "monospace",
                              fontSize: "13px",
                              maxWidth: visiblePasswords[user._id] ? 260 : 90,
                              overflow: visiblePasswords[user._id]
                                ? "visible"
                                : "hidden",
                              textOverflow: visiblePasswords[user._id]
                                ? "clip"
                                : "ellipsis",
                              whiteSpace: visiblePasswords[user._id]
                                ? "normal"
                                : "nowrap",
                              overflowWrap: visiblePasswords[user._id]
                                ? "anywhere"
                                : "normal",
                              letterSpacing: visiblePasswords[user._id]
                                ? 0
                                : 1.5,
                              color: visiblePasswords[user._id]
                                ? "#e65100"
                                : "#90a4ae",
                              fontWeight: visiblePasswords[user._id]
                                ? 600
                                : 400,
                            }}
                          >
                            {visiblePasswords[user._id] || "•".repeat(12)}
                          </Typography>
                          <Tooltip
                            title={
                              visiblePasswords[user._id]
                                ? "Hide password"
                                : "Show password"
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => togglePasswordVisibility(user._id)}
                              sx={{ color: "#1976d2", p: 0.3 }}
                            >
                              {visiblePasswords[user._id] ? (
                                <VisibilityOff sx={{ fontSize: 15 }} />
                              ) : (
                                <Visibility sx={{ fontSize: 15 }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={user.usertype}
                          size="small"
                          variant="outlined"
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={user.status}
                          size="small"
                          color={
                            user.status === "active" ? "success" : "default"
                          }
                        />
                      </TableCell>
                      <TableCell>{user.gender}</TableCell>
                      <TableCell sx={{ whiteSpace: "nowrap" }}>
                        {user.dob ? new Date(user.dob).toLocaleDateString() : ""}
                      </TableCell>
                      <TableCell sx={{ whiteSpace: "nowrap" }}>
                        {user.contactnumber}
                      </TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 160,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                      >
                        <Tooltip title={user.permanentaddress} placement="top">
                          <span>{user.permanentaddress}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                        <Tooltip title="Edit user">
                          <IconButton
                            size="small"
                            onClick={() => openEditDialog(user)}
                            sx={{ color: "#1976d2" }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete user">
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteUser(user)}
                            sx={{ color: "#d32f2f" }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {users.length > 0 && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mt={2}
            >
              <Typography variant="caption" color="text.secondary">
                Showing {(page - 1) * USERS_PAGE_SIZE + 1}–
                {(page - 1) * USERS_PAGE_SIZE + users.length} of {totalUsers}{" "}
                user(s)
              </Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <Button
                  id="btn-prev-users"
                  variant="outlined"
                  size="small"
                  startIcon={<ChevronLeftIcon />}
                  disabled={fetching || page <= 1}
                  onClick={() => goToPage(page - 1)}
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    "&:hover": { backgroundColor: "#e3f2fd" },
                  }}
                >
                  Back
                </Button>
                <Typography variant="body2" fontWeight={600} color="#374151">
                  Page {page} of {totalPages}
                </Typography>
                <Button
                  id="btn-next-users"
                  variant="outlined"
                  size="small"
                  endIcon={<ChevronRightIcon />}
                  disabled={fetching || page >= totalPages}
                  onClick={() => goToPage(page + 1)}
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    "&:hover": { backgroundColor: "#e3f2fd" },
                  }}
                >
                  Next
                </Button>
              </Stack>
            </Box>
          )}
        </Box>
      )}

      {/* ══════════════════════════════════════════════════════════════════
          DIALOG: EDIT USER
      ══════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={Boolean(editUserId)}
        onClose={closeEditDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px" } }}
      >
        <form onSubmit={handleEditSubmit} noValidate autoComplete="off">
          <DialogTitle
            sx={{
              background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <EditIcon />
            <Box>
              <Typography variant="h6" fontWeight={700}>
                Edit User
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Email ID and Status cannot be changed
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ pt: "24px !important" }}>
            <Grid container spacing={3}>
              {/* User Name */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  User Name <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  name="username"
                  placeholder="Enter full user name"
                  value={editData.username}
                  onChange={handleEditChange}
                  error={Boolean(editErrors.username)}
                  helperText={editErrors.username}
                  inputProps={{ autoComplete: "off" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid>

              {/* User Type */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  User Type <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={Boolean(editErrors.userType)}>
                  <InputLabel id="edit-user-type-label">Select User Type</InputLabel>
                  <Select
                    labelId="edit-user-type-label"
                    name="userType"
                    value={editData.userType}
                    label="Select User Type"
                    onChange={handleEditChange}
                    startAdornment={
                      <InputAdornment position="start">
                        <BadgeIcon sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }} />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="fellow">Fellow</MenuItem>
                    <MenuItem value="anganwadi">Anganwadi</MenuItem>
                    <MenuItem value="school">School</MenuItem>
                    <MenuItem value="cci">CCI</MenuItem>
                  </Select>
                  {editErrors.userType && (
                    <FormHelperText>{editErrors.userType}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Email ID (read-only) */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Email ID
                </Typography>
                <TextField
                  fullWidth
                  name="email"
                  value={editData.email}
                  disabled
                  helperText="Read-only"
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailIcon sx={{ color: "#9e9e9e" }} />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid>

              {/* Password */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Password
                </Typography>
                <TextField
                  fullWidth
                  name="password"
                  type={showEditPassword ? "text" : "password"}
                  placeholder={
                    originalPassword
                      ? "Min 8 chars, letter + digit + special char"
                      : "Leave blank to keep current password"
                  }
                  value={editData.password}
                  onChange={handleEditChange}
                  error={Boolean(editErrors.password)}
                  helperText={
                    editErrors.password ||
                    (passwordChanged && editData.password
                      ? "Password will be updated on save"
                      : "")
                  }
                  inputProps={{ autoComplete: "new-password" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon sx={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowEditPassword((v) => !v)}
                          edge="end"
                          size="small"
                        >
                          {showEditPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid>

              {/* Status (read-only) */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Status
                </Typography>
                <TextField
                  fullWidth
                  name="status"
                  value={
                    editData.status
                      ? editData.status.charAt(0).toUpperCase() +
                        editData.status.slice(1)
                      : ""
                  }
                  disabled
                  helperText="Read-only"
                  InputProps={{ readOnly: true }}
                  size="small"
                />
              </Grid>

              {/* Gender */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Gender <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={Boolean(editErrors.gender)}>
                  <InputLabel id="edit-gender-label">Select Gender</InputLabel>
                  <Select
                    labelId="edit-gender-label"
                    name="gender"
                    value={editData.gender}
                    label="Select Gender"
                    onChange={handleEditChange}
                    startAdornment={
                      <InputAdornment position="start">
                        <GenderIcon sx={{ color: "#1976d2", ml: -0.5, mr: 0.5 }} />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {editErrors.gender && (
                    <FormHelperText>{editErrors.gender}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Date of Birth */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Date of Birth <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  name="dob"
                  type="date"
                  value={editData.dob}
                  onChange={handleEditChange}
                  error={Boolean(editErrors.dob)}
                  helperText={editErrors.dob}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarIcon sx={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>

              {/* Contact Number */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Contact Number <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  name="contactNumber"
                  placeholder="Enter 10-digit mobile number"
                  value={editData.contactNumber}
                  onChange={handleEditChange}
                  error={Boolean(editErrors.contactNumber)}
                  helperText={editErrors.contactNumber}
                  inputProps={{ autoComplete: "off", maxLength: 10 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon sx={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid>

              {/* Permanent Address */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={600} mb={1} color="#374151">
                  Permanent Address <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  name="permanentAddress"
                  multiline
                  rows={3}
                  placeholder="Enter full permanent address"
                  value={editData.permanentAddress}
                  onChange={handleEditChange}
                  error={Boolean(editErrors.permanentAddress)}
                  helperText={editErrors.permanentAddress}
                  inputProps={{ autoComplete: "off" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.2 }}>
                        <HomeIcon sx={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
            <Button
              type="button"
              variant="outlined"
              color="secondary"
              onClick={closeEditDialog}
              disabled={savingEdit}
              sx={{ px: 3, borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={savingEdit}
              startIcon={
                savingEdit ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />
              }
              sx={{
                px: 4,
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#1565c0" },
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {savingEdit ? "Saving..." : "Save Changes"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  );
}

export default UserRegister;
